import { useTenantedApplicationConfig } from '../../../contexts/tenantedApplicationConfig';
import { WorkflowSchema } from '../../../types';
import { useWorkflowName } from '../useWorkflowName';

export const useWorkflowSchema = (): WorkflowSchema | undefined => {
  const config = useTenantedApplicationConfig();
  const workflowName = useWorkflowName();

  if (!workflowName) return undefined;

  const { schemas } = config;
  if (workflowName in schemas) return schemas[workflowName];

  return undefined;
};
